import React from "react";
import { Row, Col } from "antd";
import DistributionFieldsComponent from "./DistributionFilters/index";
import { UseDistributionFields } from "./DistributionFilters/useDistributionFields";
import { ReactComponent as FilterIcon } from "../../../../assets/filter.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/crossIcon.svg";
import { useSelector } from "react-redux";
import { shouldAllow } from "../../utils";

const FilterSection = ({
  handleFilter,
  handleClose,
  setFilterDataFetched,
}) => {
  const [dist, setDist, createDist, deleteDist, updateDist] =
    UseDistributionFields();

  const { isCollapsed } = useSelector((state) => state.authReducer);

  const hasFilters = () => {
    return dist.some(el => shouldAllow(el));
  };

  const handleOnClick = () => {
    let obj = {};

    let stockRegisterFilters = [];

    if (dist.length > 0) {
      dist.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value } = el;
          stockRegisterFilters.push({ [value]: name });
        }
      });
    }

    if (stockRegisterFilters.length > 0) {
      obj["stockRegisterFilters"] = stockRegisterFilters;
    }

    handleFilter(obj);
    setFilterDataFetched(true);
  };

  return (
    <Col span={24} className="ims-doc-filter-section">
      <Row align="middle" justify="space-between" className="filter-header">
        <Col className="filter-col">
          <FilterIcon /> FILTER
        </Col>
        <Col>
          <CrossIcon className="cross-icon" onClick={handleClose} />
        </Col>
      </Row>
      <Row gutter={[20, 20]} className="sections-row" justify="center">
        <Col className={`sub-sections-col${isCollapsed ? "-collapsed" : ""}`} style={{ flex: '1' }}>
          <div className="label-div">
            <span>EXPANDED FIELDS FILTERS</span>
          </div>
          <DistributionFieldsComponent
            inputFields={dist}
            setInputFields={setDist}
            createField={createDist}
            deleteField={deleteDist}
            updateField={updateDist}
            canUpdate={true}
          />
        </Col>
        <Col
          className={`sub-sections-filter-col${isCollapsed ? "-collapsed" : ""
            }`}
          style={{ marginLeft: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <div className="filter-div">
            <div
              onClick={hasFilters() ? handleOnClick : undefined}
              style={{
                cursor: hasFilters() ? 'pointer' : 'not-allowed',
                color: hasFilters() ? '#ed017f' : '#cccccc',
                border: hasFilters() ? '1px solid #ed017f' : '1px solid #cccccc',
                opacity: hasFilters() ? 1 : 0.7
              }}
            >
              Apply <br /> Filters
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default FilterSection;
